var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "batchDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("send_pagements.new_payment"),
            "close-on-click-modal": false,
            width: "739px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("send_pagements.batch_payment_details")) + " "
            ),
          ]),
          _c("div", { staticClass: "section-tip" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("tips.download_and_fill_template_batch_payments")
                ) +
                " "
            ),
          ]),
          _c("div", { staticClass: "step" }, [
            _c("div", { staticClass: "step-item" }, [
              _c("div", { staticClass: "step-item-left" }, [
                _c("div", { staticClass: "section-step-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("send_pagements.excel_worksheet_template_excel")
                      )
                  ),
                ]),
                _c("div", { staticClass: "section-tip" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "tips.latest_template_updated_supported_payment_channels"
                        )
                      )
                  ),
                ]),
              ]),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-download",
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-download",
                      },
                      on: { click: _vm.onClickDownloadBtn },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("send_pagements.download_template"))
                      ),
                    ]
                  ),
                  _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("tips.please_upload_latest_template"))
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", {
              staticClass: "line-bottom-1px",
              staticStyle: { "margin-bottom": "32px" },
            }),
            _c("div", { staticClass: "step-item" }, [
              _c("div", { staticClass: "step-item-left" }, [
                _c("div", { staticClass: "section-step-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("tips.upload_filled_excel_worksheet_template")
                      ) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "section-tip" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "tips.upload_filled_excel_using_template_batch_payments"
                        )
                      ) +
                      " "
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "section-step-title",
                    staticStyle: { "margin-bottom": "15px", color: "#1D3A71" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("tips.following_three_situations_cause_fail")
                        ) +
                        " "
                    ),
                  ]
                ),
                _c("div", { staticClass: "situations-tip" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("tips.spaces_in_the_amount")) + " "
                  ),
                ]),
                _c("div", { staticClass: "situations-tip" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("tips.spaces_in_the_email_address")) +
                      " "
                  ),
                ]),
                _vm.$store.getters.curCountry.country_code !== "RU"
                  ? _c("div", { staticClass: "situations-tip" }, [
                      _vm._v(" " + _vm._s(_vm.walletAccountNumberTip) + " "),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                [
                  _c(
                    "UploadExcelFile",
                    _vm._g(
                      {
                        attrs: { "reference-batch-no": _vm.reference_batch_no },
                        on: {
                          templateFileSuccess: _vm.templateFileSuccess,
                          templateFileFail: _vm.getReferenceBatchNo,
                        },
                      },
                      _vm.$listeners
                    )
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }